const Queue = require('./src/Queue');
module.exports = Queue;

